import {
  Tag, TagApi, TagMutation, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedTagApi extends TagApi {
  getTags (options?: any): AxiosPromise<Array<Tag>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getTags(undefined, optionsParam)
  }

  createTag (tagRequestBody: TagMutation, options?: any): AxiosPromise<Tag> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createTag(tagRequestBody, undefined, optionsParam)
  }

  getTag (id: number, options?: any): AxiosPromise<Tag> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getTag(id, undefined, optionsParam)
  }

  updateTag (id: number, tagRequestBody: TagMutation, options?: any): AxiosPromise<Tag> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateTag(id, tagRequestBody, undefined, optionsParam)
  }

  deleteTag (id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deleteTag(id, undefined, optionsParam)
  }
}
